import React, {
  useState, useEffect, forwardRef, useImperativeHandle,
} from 'react';
import _, { startCase } from 'lodash';
import { apiRequestState, get, set } from '../../../utility/utility';
import CoreFormDualAction from '../../core/form/CoreFormDualAction';
import { INSPECTION_ROLES } from '../../../utility/InspectionsUtils';

const InspectionFormDocumentVisibility = forwardRef(({
  inspectionsPutIsLoading,
  dispatchInspectionsPut,
}, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentInspection, setCurrentInspection] = useState(null);
  const [documentsState, setDocumentsState] = useState([]);
  const visibilityOptions = Object.keys(INSPECTION_ROLES);

  useImperativeHandle(ref, () => ({
    open: (inspection, documentIds) => {
      setCurrentInspection(inspection);
      const matchingDocuments = get(inspection, 'onsite.documents', []).filter((document) => documentIds.includes(get(document, '_id').toString()));

      setDocumentsState(matchingDocuments);
      setIsOpen(true);
    },
    close: () => setIsOpen(false),
  }));

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!inspectionsPutIsLoading) {
      closeModal();
    }
  }, [inspectionsPutIsLoading]);

  if (!isOpen) return null;

  const toggleVisibility = (docIndex, role) => {
    setDocumentsState((prev) => {
      const updated = [...prev];
      const doc = { ...updated[docIndex] };
      const currentVisibility = new Set(doc.roleVisibility || []);

      if (currentVisibility.has(role)) {
        currentVisibility.delete(role);
      } else {
        currentVisibility.add(role);
      }

      doc.roleVisibility = Array.from(currentVisibility);
      updated[docIndex] = doc;

      return updated;
    });
  };

  const handleSave = (inspection) => {
    const update = {};
    set(update, 'onsite.documentsToUpdate', documentsState);
    dispatchInspectionsPut(inspection, update);
  };

  return (
    <CoreFormDualAction
      title="Document Visibility"
      primaryButtonCaption="Save"
      primaryButtonCallback={() => handleSave(currentInspection)}
      primaryButtonCallbackStatus={inspectionsPutIsLoading}
      secondaryButtonCaption="Cancel"
      secondaryButtonCallback={closeModal}
    >
      <div style={{
        display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', fontWeight: '600', padding: '10px 0',
      }}
      >
        <div>Filename</div>
        {visibilityOptions.map((option) => (
          <div key={option}>{startCase(option)}</div>
        ))}
      </div>

      {documentsState.map((document, index) => (
        <div
          key={get(document, '_id')}
          style={{
            display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', paddingBottom: '8px', alignItems: 'center',
          }}
        >
          <div style={{ paddingLeft: '10px' }}>{get(document, 'filename')}</div>
          {visibilityOptions.map((option) => (
            <div>
              <input
                type="checkbox"
                checked={get(document, 'roleVisibility', []).includes(option)}
                onChange={() => toggleVisibility(index, option)}
                disabled={option === INSPECTION_ROLES.admin}
              />
            </div>
          ))}
        </div>
      ))}
    </CoreFormDualAction>
  );
});

export default InspectionFormDocumentVisibility;
